import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCampaignCtrPerformance,
  BackendQueryCampaignCtrPerformanceArgs,
} from 'src/types/backend';

const QUERY = gql`
  query CampaignCtrPerformance(
    $campaignId: ID!
    $segmentId: ID
    $startDate: ISO8601Date
    $endDate: ISO8601Date
  ) {
    campaignCtrPerformance(
      campaignId: $campaignId
      segmentId: $segmentId
      startDate: $startDate
      endDate: $endDate
    ) {
      upliftPercentage
      totalBaseline {
        clicks
        views
      }
      totalAnyword {
        clicks
        views
      }
      performanceRows {
        dateTime
        isTraffic
        clicks
        views
      }
      resultsState
    }
  }
`;

type Variables = BackendQueryCampaignCtrPerformanceArgs;
type Result = BackendCampaignCtrPerformance;

export const queryCampaignCtrPerformance = async (variables: Variables) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
